import React, { Component } from 'react'
import CategoryList from '../categories/CategoryList';
import Movies from '../movies/Movies';
import "../root/app.css"

export default class DashBoard extends Component {
    
    render() {
        return (
            <div className="app">
             
                    <div  className="movie-part w-100">
                        <div className="category_part menu-part menu">
                            <CategoryList/>
                        </div>
                            <Movies/>
                    </div>
                   
            </div>
        )
    }
}
